import React from 'react'

import { useParams, useNavigate } from 'react-router-dom'

import { useFindTask } from '@hooks/task/find'

import { useGetLinks } from './links'
import { BoldText, InfoContainer, Link, Paper, RegularText } from './styles'

export function DownstreamCard() {
  const { taskId } = useParams<{ taskId: string }>()
  const { data: rawTask } = useFindTask(Number(taskId))
  const { getNotificationURL, getWorkOrderURL } = useGetLinks()
  const task = rawTask ?? ({} as NonNullable<typeof rawTask>)

  function openNotificationURL() {
    const notificationURL = getNotificationURL(task.job?.notification ?? '')
    window.open(notificationURL, '_blank')
  }

  function openWorkOrderURL() {
    const workOrderURL = getWorkOrderURL({
      code: task.job?.code ?? '',
      workOrder: task.job?.workOrder ?? '',
    })

    window.open(workOrderURL, '_blank')
  }

  return (
    <Paper>
      <BoldText>{task?.job?.name}</BoldText>
      <InfoContainer>
        <RegularText>Project </RegularText>
        <BoldText>{task.job?.project.code}</BoldText>
      </InfoContainer>
      <InfoContainer>
        <RegularText>Plant Section </RegularText>
        <BoldText>{task.job?.plantSection?.description}</BoldText>
      </InfoContainer>
      <InfoContainer>
        <RegularText>Location </RegularText>
        <BoldText>{task.job?.location?.description}</BoldText>
      </InfoContainer>
      <InfoContainer>
        <RegularText>Lead Supervisor </RegularText>
        <BoldText>{task.job?.leadSupervisor.description}</BoldText>
      </InfoContainer>
      <InfoContainer>
        <RegularText>Functional Location </RegularText>
        <BoldText>{task.job?.functionalLocation}</BoldText>
      </InfoContainer>
      <InfoContainer>
        <RegularText>Equipment </RegularText>
        <BoldText>{task.job?.equipmentTag}</BoldText>
      </InfoContainer>
      <InfoContainer>
        <RegularText>WO </RegularText>
        <button onClick={openWorkOrderURL}>
          <Link>{task.job?.workOrder ? `#${task.job?.workOrder}` : ''}</Link>
        </button>
      </InfoContainer>
      <InfoContainer>
        <RegularText>Notification </RegularText>
        <button onClick={openNotificationURL}>
          <Link>
            {task.job?.notification ? `#${task.job?.notification}` : ''}
          </Link>
        </button>
      </InfoContainer>
    </Paper>
  )
}
